import VistaprintAuth from '@vp/auth';

const DIRECT_ACCESS_AUTH_CLIENT_ID = 'iL1tKEcH1Dc0rWBDvYk2fttkiio4V3Ph';
const CULTURE = 'en-IE';

// TODO: We cannot support handling token processing for our other SPA Client (InternalView) unless we host that at a different location on the preview environment.
// alternatively, if the VP Auth library allows for configurability of the redirect path (rather than the root) we could just host this on the proper branch path.
VistaprintAuth.init({ developmentMode: { clientID: DIRECT_ACCESS_AUTH_CLIENT_ID }, culture: CULTURE});
